module.exports = __webpack_public_path__ + "img/success.887e70c7.png";